import React from "react";
import { useTheme } from "../../../util";
import { cn, getFocusRingStyles } from "../../../styles";
import { ThemeColor } from "../../../props";
import defaultLightLogo from "./logo_peak-solution.png";
import defaultDarkLogo from "./logo_peak-solution_dark.png";

export interface PeakLogoProps {
  /** Wrap the logo in a link to this URL. Pass null to render the image only. */
  url?: string | null;
  /** Light-mode logo override (e.g. tenant branding). Falls back to the default Peak logo. */
  lightSrc?: string;
  /** Dark-mode logo override. Falls back to lightSrc, then the default Peak logo. */
  darkSrc?: string;
  height?: number | string;
  alt?: string;
  className?: string;
}

export function PeakLogo({
  url = "/",
  lightSrc,
  darkSrc,
  height = 30,
  alt = "Logo Peak Solution GmbH",
  className,
}: PeakLogoProps) {
  const { isGlobalDarkMode } = useTheme();
  const src = isGlobalDarkMode
    ? darkSrc || lightSrc || defaultDarkLogo
    : lightSrc || defaultLightLogo;

  const img = (
    <img className={cn("w-auto", className)} style={{ height }} src={src} alt={alt} />
  );

  if (!url) return img;

  return (
    <a
      href={url}
      className={cn(
        "p-2 outline-none focus-visible:ring-2 rounded",
        getFocusRingStyles(ThemeColor.primary),
      )}
    >
      {img}
    </a>
  );
}
